import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import CatalogService from "../../services/catalog.service";
import OrderService from "../../services/order.service";
import Carousel from "react-bootstrap/Carousel";
import Card from "react-bootstrap/Card";
import Spinner from "react-bootstrap/Spinner";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import AnimateHeight from "react-animate-height";
import ChooseAddress from "../ChooseAddress";
import AddressForm from "../modals/AddressForm";

import ButtonGroup from "react-bootstrap/ButtonGroup";
import { selectCurrentNewHireKitItems, getNewHireKitItems, selectDecorations, selectInventory } from '../../reducers/catalog';
import { addItemToOrder, cartCount, toggleShowCart, cart, updateItemQuantity } from '../../reducers/cart';
import { isLoggedIn } from '../../reducers/auth';
import { useParams, useLocation, useNavigate } from "react-router-dom";
import { Container, Row, Col, ResponsiveEmbed } from 'react-bootstrap';
import NewHireKitItem from "./NewHireKitItem";
import ConfirmNewHireKitModal from "../modals/ConfirmNewHireKitModal";

const AdminNewHireKit = () => {
    const dispatch = useDispatch();
    const catalogItem = useSelector(selectCurrentNewHireKitItems);
    const inventory = useSelector(selectInventory);
    const itemStatus = useSelector(state => state.catalog.adminItemStatus)
    const [currentSize, setCurrentSize] = useState(null);
    const [selectedSizes, setSelectedSizes] = useState(new Map());
    const [height, setHeight] = useState(0);
    const [newAddress, setNewAddress] = useState(null);
    const [isExpanded, setIsExpanded] = useState(false);
    const [errorMessage, setErrorMessage] = useState(null);
    const [savingOrder, setSavingOrder] = useState(false);
    const [showConfirmation, setShowConfirmation] = useState(false);
    const [orderItems, setOrderItems] = useState([]);

    const location = useLocation();
    let navigate = useNavigate();

    const gotoLogin = () => {
        navigate("/login");
    }



    const formatPantsSize = (sizeName) => {
        var isFour = /^\d{4}$/.test(sizeName);
        if (isFour) {
            return sizeName.substring(0, 2) + "x" + sizeName.substring(2);
        } else {
            return sizeName;
        }
    }

    const sizeClick = (event) => {
        setCurrentSize(event.target.getAttribute("data"));
    }

    useEffect(() => {
        dispatch(getNewHireKitItems());
    }, [location.key]);


    useEffect(() => {
        if (itemStatus === 'idle') {
            dispatch(getNewHireKitItems());
        }
    }, [itemStatus, dispatch]);

    const setSize = (itemId, sizeId) => {
        var newSelectedSizes = new Map(selectedSizes);
        newSelectedSizes.set(itemId, sizeId);
        setSelectedSizes(newSelectedSizes);
    }

    const remove = async (item) => {
        await CatalogService.removeNewHireKitItem(item.nhkiId);
        dispatch(getNewHireKitItems());
    }

    let content = "";
    let price = 0;

    if (itemStatus === 'loading') {
        content = <Spinner text="Loading..." />
    } else if (itemStatus === 'succeeded') {
        if (catalogItem && catalogItem.items && catalogItem.items.length > 0) {
            console.log("ITEMS", catalogItem);
            price = catalogItem.items[0].sizes[0].price;
            let sizes = new Array();

            let currItem = catalogItem.items[0];

            for (var i = 0; i < currItem.sizes.length; i++) {
                var inv = inventory.find(item => item.uniqueKey == currItem.sizes[i].uniqueKey);
                console.log("INV", inv);
                if (inv && inv.quantity == 0) {
                    sizes.push(<div><Button style={{ backgroundColor: currentSize === i ? "blue" : "" }} key={i} variant="secondary" data={i} disabled>{formatPantsSize(currItem.sizes[i].sizeName)}<br />{inv?.quantity}</Button></div>);

                } else {
                    sizes.push(<div><Button style={{ backgroundColor: currentSize === i ? "blue" : "" }} key={i} variant="secondary" data={i} onClick={(event) => { sizeClick(event); }}>{formatPantsSize(currItem.sizes[i].sizeName)}<br />{inv?.quantity}</Button></div>);
                }
            }

            content = (
                <Container>
                    {catalogItem.items.map((item, i) => (
                        <NewHireKitItem item={item} inventory={inventory} setSize={setSize} remove={remove} edit={true} />
                    ))}
                </Container>
            );
        } else {
            content = <div>No items found. Go to a Product and Add to New Hire Kit</div>
        }

    } else if (itemStatus === 'failed') {
        content = <div>error</div>
    }

    const closeAddressForm = (value) => {
        setHeight(0);
        setIsExpanded(false);
    }

    const setAddress = (address) => {
        console.log("SET ADDRESS", address);
        setNewAddress(address);
        setIsExpanded(false);
    }

    const toggleExpansion = () => {
        console.log("TOGGLE EXPANSION", isExpanded);
        var expanded = isExpanded;
        setIsExpanded(!isExpanded);
        setHeight(expanded ? 0 : 'auto');
    };


    const submitNewHireKit = async () => {
        setSavingOrder(true);
        var newOrderItems = [];
        console.log("SUBMITTING NEW HIRE KIT");
        var error = false;
        var errorMessage = "";
        if (catalogItem.items.length != selectedSizes.size) {
            errorMessage = "Please select a size for all items. ";
            error = true;
        }

        if (newAddress == null || newAddress.name == null) {
            errorMessage += "Please add a recipient address.";
            error = true;
        }

        if (error) {
            setErrorMessage(errorMessage);
            setSavingOrder(false);
            return;
        }

        console.log("ADDING ITEMS");
        for (var i = 0; i < catalogItem.items.length; i++) {
            var selectedSizeProductId = selectedSizes.get(catalogItem.items[i].nhkiId);
            var selectedSize = catalogItem.items[i].sizes.find(size => size.productId == selectedSizeProductId);
            var item = { productId: selectedSizeProductId, decorations: catalogItem.items[i].logos, item: catalogItem.items[i], selectedSize: selectedSize.sizeName };
            console.log("ADDING ITEM", item);
            newOrderItems.push(item);
        }
        setOrderItems(newOrderItems);
        setShowConfirmation(true);
    }

    const confirm = async () => {
        await OrderService.orderNewHireKit(orderItems, newAddress);
        setShowConfirmation(false);
        setSavingOrder(false);
        setNewAddress(null);
        setSelectedSizes(new Map());
        navigate("/admin/newhirekits");
    }
    const closeAddressModal = async (update, newAddress) => {
        toggleExpansion();
        if (update) {
            await setNewAddress(newAddress);
        }
    }

    return (
        <Container>
            <h2>New Hire Kit Order</h2>
            <hr />
            <h4>Recipient</h4>
            <div style={{ marginLeft: 30 }}>
                <AnimateHeight duration={500} height={height == 0 ? 'auto' : 0}>
                    {newAddress && (
                        <div>
                            <h2>Delivering to {newAddress.name}</h2>
                            <p style={{ marginLeft: 30, padding: 5, border: "1px solid #CCCCCC" }}>{newAddress.street}<br />
                                {newAddress.street2 != null && newAddress.street2 != "" && <>{newAddress.street2}<br /></>}
                                {newAddress.city}, {newAddress.state} {newAddress.zip}<br />
                            </p>

                        </div>)}
                    <div><Button onClick={toggleExpansion}>Set Address</Button></div>
                </AnimateHeight>
                <AnimateHeight duration={500} height={height}>
                    <ChooseAddress close={closeAddressModal} />
                </AnimateHeight>
            </div>
            <hr />
            {content}
            <hr />
            <Button onClick={submitNewHireKit} variant="primary" style={{ marginTop: 20 }}>
                Confirm New Hire Kit
            </Button>
            {errorMessage && <div className="error">{errorMessage}</div>}
            {showConfirmation && orderItems && <ConfirmNewHireKitModal show={showConfirmation} close={() => setShowConfirmation(false)} confirm={confirm} items={orderItems} address={newAddress} />}
        </Container >
    );
};
export default AdminNewHireKit;